import { render, staticRenderFns } from "./FoodMenuManage.vue?vue&type=template&id=35d56bf4&"
import script from "./FoodMenuManage.vue?vue&type=script&lang=js&"
export * from "./FoodMenuManage.vue?vue&type=script&lang=js&"
import style0 from "./FoodMenuManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports